import { api } from '../api.js';
import { boot } from '../app.js';
import { register, go, $ } from '../ui.js';
import { stopQueue } from '../queue.js';
import { validateProfile } from '../../src/profile.js';

let config, widget, token = '', attempt = null, challenge = null, epoch = 0, busy = false, script;
let step = 'entry', path = 'signin', completing = false, transition, checkEpoch = 0;
const empty = () => ({ country: '', birthdate: '', phone: '' });
let draft = empty();
const messages = {
  unsupported_phone: 'use a mobile number in the us or türkiye.', adult_required: 'you must be 18 or older to join.',
  invalid_birthdate: 'enter a valid birthdate.', try_later: 'too many attempts. please try later.', try_again: 'too many attempts. please try later.',
  incorrect_code: 'that code didn’t work. try again.', request_new_code: 'that code has expired or been used. request a new code.',
  check_failed: 'please complete the security check again.', auth_unavailable: 'sign-in is temporarily unavailable.',
  please_wait: 'your code is being sent. try again in a moment.',
};
const titles = { country: 'where are you joining from?', birthdate: 'your birthdate?', phone: 'your phone number?' };
const dial = () => draft.country === 'TR' ? '+90' : '+1';
function nationalDigits(value) {
  let digits = value.replace(/[\s().-]/g, '');
  if (digits.startsWith(dial())) digits = digits.slice(dial().length);
  return /^\d{0,10}$/.test(digits) ? digits : null;
}
function formattedPhone(value) {
  const digits = nationalDigits(value); if (digits === null) return value;
  let offset = 0;
  return (draft.country === 'TR' ? [3, 3, 2, 2] : [3, 3, 4]).map(size => { const group = digits.slice(offset, offset + size); offset += size; return group; }).filter(Boolean).join('-');
}
const profile = () => ({ birthdate: draft.birthdate });
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const pad = value => String(value).padStart(2, '0');
months.forEach((month, index) => $('birth-month').add(new Option(month, pad(index + 1))));
for (let year = new Date().getUTCFullYear(); year >= 1900; year--) $('birth-year').add(new Option(String(year), String(year)));
function updateDays() {
  const month = $('birth-month').value, year = $('birth-year').value, selected = $('birth-day').value;
  const days = month ? new Date(Date.UTC(Number(year) || 2000, Number(month), 0)).getUTCDate() : 31;
  $('birth-day').replaceChildren(new Option('—', ''));
  for (let day = 1; day <= days; day++) $('birth-day').add(new Option(String(day), pad(day)));
  $('birth-day').value = Number(selected) <= days ? selected : '';
}
for (const id of ['birth-month', 'birth-year']) $(id).addEventListener('change', updateDays);
function showError(code) { $('gate-error').textContent = messages[code] || code; $('gate-error').hidden = false; }
function error(e) {
  if (e.data?.error === 'access_required') return go('access');
  if (e.status === 401) return go('gate');
  showError(messages[e.data?.error] || 'couldn’t sign in. please try again.');
}
function render() {
  $('gate-submit').textContent = busy ? 'please wait…' : step === 'phone' ? 'send code' : 'continue';
  $('gate-submit').disabled = busy || (step === 'country' && !draft.country) || (step === 'phone' && (!config?.ready || !token));
  for (const id of ['gate-back', 'gate-change', 'gate-phone', 'gate-code', 'birth-month', 'birth-day', 'birth-year']) $(id).disabled = busy;
  $('gate-back').textContent = completing ? 'sign out' : 'back';
  for (const button of document.querySelectorAll('[data-auth-country]')) {
    button.disabled = busy; button.setAttribute('aria-pressed', String(button.dataset.authCountry === draft.country));
  }
}
function save() {
  if (step === 'birthdate') draft.birthdate = [$('birth-year').value, $('birth-month').value, $('birth-day').value].join('-');
  if (step === 'phone') draft.phone = $('gate-phone').value;
}
function setStep(next) {
  save(); step = next; transition?.cancel();
  $('auth-entry').hidden = next !== 'entry'; $('gate-form').hidden = next === 'entry';
  $('app').dataset.entry = String(next === 'entry'); $('gate-form').dataset.step = next;
  for (const [id, active] of Object.entries({ 'country-fields': next === 'country', 'birthdate-fields': next === 'birthdate', 'phone-fields': next === 'phone', 'code-fields': next === 'code' })) $(id).hidden = !active;
  $('gate-title').textContent = next === 'code' ? (path === 'signup' ? 'verify your number' : 'your sign-in code') : titles[next] || '';
  $('gate-error').hidden = true;
  if (next === 'birthdate') {
    const [year = '', month = '', day = ''] = draft.birthdate.split('-');
    $('birth-year').value = year; $('birth-month').value = month; updateDays(); $('birth-day').value = day;
  }
  if (next === 'phone') {
    $('gate-prefix').textContent = dial(); $('gate-phone').value = draft.phone;
    if (config?.ready) challengeWidget().catch(() => { if (step === 'phone') showError('auth_unavailable'); });
    else showError('auth_unavailable');
  } else removeWidget();
  if (next === 'code') $('gate-number').textContent = dial() + ' ' + formattedPhone(draft.phone);
  render();
  const panel = next === 'entry' ? $('auth-entry') : $('gate-form');
  if (!matchMedia('(prefers-reduced-motion:reduce)').matches) transition = panel.animate([{ opacity: 0, filter: 'blur(5px)' }, { opacity: 1, filter: 'blur(0)' }], { duration: 350, easing: 'ease-out' });
  if (next === 'entry') $('auth-signup').focus(); else $('gate-title').focus({ preventScroll: true });
}
function removeWidget() {
  ++checkEpoch; token = '';
  if (widget !== undefined) { window.turnstile?.remove(widget); widget = undefined; }
}
async function challengeWidget() {
  removeWidget(); const current = epoch, generation = checkEpoch;
  if (!script) script = new Promise((resolve, reject) => {
    if (window.turnstile) return resolve();
    const tag = document.createElement('script'); tag.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    tag.onload = resolve; tag.onerror = reject; document.head.append(tag);
  }).catch(e => { script = null; throw e; });
  await script;
  if (current !== epoch || generation !== checkEpoch || step !== 'phone') return;
  widget = window.turnstile.render('#phone-check', {
    sitekey: config.siteKey, action: 'phone-login',
    callback: value => { if (current === epoch && generation === checkEpoch && step === 'phone') { token = value; render(); } },
    'expired-callback': () => { if (generation === checkEpoch) { token = ''; render(); } },
    'error-callback': () => { if (generation === checkEpoch) { token = ''; render(); } },
  });
}
function restartCode() { attempt = challenge = null; $('gate-code').value = ''; setStep('phone'); }
for (const mode of ['signup', 'signin']) $('auth-' + mode).addEventListener('click', () => {
  path = mode; draft = empty(); setStep('country');
});
for (const button of document.querySelectorAll('[data-auth-country]')) button.addEventListener('click', () => {
  if (busy) return;
  if (draft.country !== button.dataset.authCountry) { draft.phone = ''; $('gate-phone').value = ''; attempt = challenge = null; }
  draft.country = button.dataset.authCountry; render();
});
$('gate-change').addEventListener('click', () => { if (!busy) restartCode(); });
$('gate-phone').addEventListener('input', () => {
  const input = $('gate-phone'), raw = input.value, prefix = raw.startsWith(dial()) ? dial().length - 1 : 0;
  const count = Math.max(0, raw.slice(0, input.selectionStart ?? raw.length).replace(/\D/g, '').length - prefix);
  input.value = formattedPhone(raw);
  let position = 0, digits = 0;
  while (position < input.value.length && digits < count) { if (/\d/.test(input.value[position])) digits++; position++; }
  input.setSelectionRange(position, position);
});
$('gate-form').addEventListener('input', () => { $('gate-error').hidden = true; });
$('gate-back').addEventListener('click', () => {
  if (busy) return;
  if (step === 'code') return restartCode();
  if (completing) return logout();
  const previous = { country: 'entry', phone: 'country' };
  setStep(previous[step]);
});
$('gate-form').addEventListener('submit', async event => {
  event.preventDefault(); if (busy) return; save(); $('gate-error').hidden = true;
  if (step === 'country') { if (draft.country) setStep('phone'); return; }
  if (step === 'birthdate') {
    const checked = validateProfile(profile()); if (checked.error) return showError(checked.error);
  }
  if (step === 'phone') {
    if (!config?.ready || !token) return;
    const digits = nationalDigits(draft.phone);
    if (!/^\d{10}$/.test(digits) || (draft.country === 'TR' && !digits.startsWith('5')) || (draft.country === 'US' && !/^[2-9]/.test(digits))) return showError('enter your 10-digit mobile number.');
    draft.phone = digits; $('gate-phone').value = digits;
  }
  if (step === 'code' && !/^\d{6}$/.test($('gate-code').value)) return showError('enter the 6-digit code.');
  busy = true; render(); const current = epoch;
  try {
    if (completing) {
      await api('/api/profile', { method: 'POST', body: profile() });
      if (current !== epoch) return; await boot();
    } else if (step === 'code') {
      await api('/api/auth/verify', { method: 'POST', body: { challengeId: challenge.challengeId, proof: attempt.proof, code: $('gate-code').value } });
      if (current !== epoch) return; await boot();
    } else {
      const phone = dial() + draft.phone;
      if (!attempt || attempt.phone !== phone) attempt = { phone, requestId: crypto.randomUUID(), proof: [...crypto.getRandomValues(new Uint8Array(32))].map(x => x.toString(16).padStart(2, '0')).join('') };
      const result = await api('/api/auth/start', { method: 'POST', body: { ...attempt, turnstileToken: token } });
      if (current !== epoch) return; challenge = result; setStep('code'); $('gate-code').focus();
    }
  } catch (e) {
    if (current === epoch) { error(e); if (current === epoch && step === 'phone') { token = ''; window.turnstile?.reset(widget); } }
  } finally { if (current === epoch) { busy = false; render(); } }
});
async function logout() {
  $('sign-out').disabled = true;
  try { await api('/api/logout', { method: 'POST' }); stopQueue(); go('gate'); }
  catch { if (completing) showError('couldn’t sign out. try again.'); else $('sign-out').textContent = 'try signing out again'; }
  finally { $('sign-out').disabled = false; }
}
$('sign-out').addEventListener('click', logout);
register({ gate: {
  async enter(params = {}) {
    const current = ++epoch; stopQueue(); busy = false; config = null; draft = empty(); completing = !!params.completeProfile;
    path = completing ? 'signup' : 'signin'; attempt = challenge = null; token = '';
    setStep(completing ? 'birthdate' : 'entry');
    if (completing) return;
    try { const value = await api('/api/auth/config'); if (current !== epoch) return; config = value; if (step === 'phone') setStep('phone'); }
    catch (e) { if (current === epoch && e.data?.error === 'access_required') go('access'); }
  },
  leave() { ++epoch; busy = false; removeWidget(); transition?.cancel(); $('app').dataset.entry = 'false'; draft = empty(); for (const id of ['birth-month', 'birth-day', 'birth-year', 'gate-phone', 'gate-code']) $(id).value = ''; }
} });
